"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _logrocket = _interopRequireDefault(require("logrocket"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _semanticUiReact = require("semantic-ui-react");

var _shift4iframe = _interopRequireDefault(require("./shift4iframe"));

var _CartDisplay = _interopRequireDefault(require("./CartDisplay"));

var _CheckoutMessage = _interopRequireDefault(require("./CheckoutMessage"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CheckoutBody = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CheckoutBody, _React$Component);

  var _super = _createSuper(CheckoutBody);

  function CheckoutBody(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckoutBody);
    _this = _super.call(this, props);
    _this.state = {
      firstName: '',
      lastName: '',
      email: '',
      note: '',
      phoneNumber: '',
      tip: 0.0,
      validatedCart: null,
      error: undefined,
      errors: [],
      loadingError: undefined,
      cartLoading: true,
      iframeLoading: true,
      paymentLoading: false,
      orderPlaced: false,
      success: false
    };
    _this.setLoading = _this.setLoading.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMaskedChange = _this.handleMaskedChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSuccess = _this.handleSuccess.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFailure = _this.handleFailure.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCheckoutFailure = _this.handleCheckoutFailure.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCartFailure = _this.handleCartFailure.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePaymentSuccess = _this.handlePaymentSuccess.bind((0, _assertThisInitialized2["default"])(_this));
    _this.resetErrors = _this.resetErrors.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(CheckoutBody, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _yield$this$getCartDe, data;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (process.env.NODE_ENV === 'production') {
                  _logrocket["default"].init('abqepz/skytab-takeout-websites');
                }

                _context.prev = 1;
                _context.next = 4;
                return this.getCartDetails();

              case 4:
                _yield$this$getCartDe = _context.sent;
                data = _yield$this$getCartDe.data;
                this.setState({
                  validatedCart: data
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);

                _logrocket["default"].captureException(_context.t0);

                this.handleCartFailure(_context.t0);

              case 13:
                _context.prev = 13;
                this.setLoading('cartLoading', false);
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9, 13, 16]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "getCartDetails",
    value: function () {
      var _getCartDetails = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this$props, cart, locationId, host;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, cart = _this$props.cart, locationId = _this$props.locationId;
                host = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
                return _context2.abrupt("return", _axios["default"].post("".concat(host, "ordering/cart/"), _objectSpread({
                  locationId: locationId
                }, cart)));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCartDetails() {
        return _getCartDetails.apply(this, arguments);
      }

      return getCartDetails;
    }()
  }, {
    key: "setLoading",
    value: function setLoading(name, value) {
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "submitCheckout",
    value: function () {
      var _submitCheckout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(payment) {
        var _this$state, firstName, lastName, email, phoneNumber, tip, note, validatedCart, _this$props2, locationId, clearCart, data, host, response;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setLoading('paymentLoading', true);
                _context3.prev = 1;
                _this$state = this.state, firstName = _this$state.firstName, lastName = _this$state.lastName, email = _this$state.email, phoneNumber = _this$state.phoneNumber, tip = _this$state.tip, note = _this$state.note, validatedCart = _this$state.validatedCart;
                _this$props2 = this.props, locationId = _this$props2.locationId, clearCart = _this$props2.cart.clearCart;
                data = {
                  customer: {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    phoneNumber: phoneNumber
                  },
                  tip: tip,
                  payment: payment,
                  note: note,
                  shopping_cart_id: validatedCart.cart.id,
                  location_id: locationId
                };
                host = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
                this.setLoading('paymentLoading', true);

                _logrocket["default"].identify("".concat(firstName, " ").concat(lastName, " @ ").concat(locationId, "/").concat(data.shopping_cart_id));

                _context3.next = 10;
                return _axios["default"].post("".concat(host, "ordering/payments/locations/").concat(locationId, "/complete_sale/"), data);

              case 10:
                response = _context3.sent;

                if (response.status === 200) {
                  this.handlePaymentSuccess();

                  if (clearCart) {
                    clearCart();
                  }
                }

                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](1);

                _logrocket["default"].captureException(_context3.t0);

                this.handleCheckoutFailure(_context3.t0);

              case 18:
                _context3.prev = 18;
                this.setLoading('paymentLoading', false);
                this.setLoading('cartLoading', false);
                return _context3.finish(18);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 14, 18, 22]]);
      }));

      function submitCheckout(_x) {
        return _submitCheckout.apply(this, arguments);
      }

      return submitCheckout;
    }()
  }, {
    key: "handlePaymentSuccess",
    value: function handlePaymentSuccess() {
      this.setState({
        success: true
      });
    }
  }, {
    key: "handleCartFailure",
    value: function handleCartFailure(error) {
      if (!error) return;
      var defaultError = 'There was an error loading your cart, please try again';

      var data = _lodash["default"].get(error, 'response.data'); // If response.data is a string use it


      if (typeof data === 'string' && _lodash["default"].toLength(data)) {
        return this.setState({
          loadingError: data,
          orderPlaced: false
        });
      } // If response.data.errors is a list, get the first error and use it


      var firstError = _lodash["default"].get(data, 'errors[0]');

      if (firstError && typeof firstError === 'string') {
        return this.setState({
          loadingError: firstError,
          orderPlaced: false
        });
      } // If response.data.error is a string use it


      var loadingError = _lodash["default"].get(data, 'error');

      if (loadingError && typeof loadingError === 'string') {
        return this.setState({
          loadingError: loadingError,
          orderPlaced: false
        });
      } // Return default error


      return this.setState({
        loadingError: defaultError,
        orderPlaced: false
      });
    }
  }, {
    key: "handleCheckoutFailure",
    value: function handleCheckoutFailure(error) {
      if (!error) return;
      var defaultError = 'There was an issue processing your payment';

      var data = _lodash["default"].get(error, 'response.data'); // If response.data is a string use it


      if (typeof data === 'string' && _lodash["default"].toLength(data)) {
        return this.setState({
          error: error,
          orderPlaced: false
        });
      } // If response.datae is an object check for known values and return error message


      if ((0, _typeof2["default"])(data) === 'object') {
        if (Object.keys(data).includes('first_name') || Object.keys(data).includes('last_name') || Object.keys(data).includes('email') || Object.keys(data).includes('phone_number')) {
          var missingFields = Object.keys(data).map(function (err) {
            return "Missing ".concat(err.replace('_', ' '));
          });
          return this.setState({
            error: 'Please provide the following contact information:',
            errors: missingFields,
            orderPlaced: false
          });
        }
      } // If response.data.errors is a list, get the first error and use it


      var firstError = _lodash["default"].get(data, 'errors[0]');

      if (firstError && typeof firstError === 'string') {
        return this.setState({
          error: firstError,
          orderPlaced: false
        });
      } // If response.data.error is a string use it


      var checkoutError = _lodash["default"].get(data, 'error');

      if (checkoutError && typeof checkoutError === 'string') {
        return this.setState({
          error: checkoutError,
          orderPlaced: false
        });
      } // Return default error


      return this.setState({
        error: defaultError,
        orderPlaced: false
      });
    }
  }, {
    key: "handleMaskedChange",
    value: function handleMaskedChange(e) {
      return this.handleChange(e, e.target);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e, target) {
      var value = target.value,
          name = target.id;

      if (name === 'tip') {
        this.setState((0, _defineProperty2["default"])({}, name, value ? Math.abs(parseFloat(value)) : null));
      } else {
        this.setState((0, _defineProperty2["default"])({}, name, value));
      }
    }
  }, {
    key: "handleSuccess",
    value: function () {
      var _handleSuccess = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(data) {
        var _this2 = this;

        var _this$state2, orderPlaced, iframeLoading;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$state2 = this.state, orderPlaced = _this$state2.orderPlaced, iframeLoading = _this$state2.iframeLoading;

                if (!orderPlaced && !iframeLoading) {
                  this.setState({
                    orderPlaced: true
                  }, function () {
                    return _this2.submitCheckout(data);
                  });
                }

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleSuccess(_x2) {
        return _handleSuccess.apply(this, arguments);
      }

      return handleSuccess;
    }()
  }, {
    key: "handleFailure",
    value: function handleFailure(data) {
      var error = 'There was an issue processing your payment';
      if (data.i4go_responsetext) _logrocket["default"].captureMessage(data.i4go_responsetext);

      if (data && data.i4go_responsetext) {
        error = data.i4go_responsetext;
      }

      return this.setState({
        error: error,
        orderPlaced: false
      });
    }
  }, {
    key: "resetErrors",
    value: function resetErrors() {
      this.setState({
        error: undefined,
        errors: [],
        loadingError: undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state3 = this.state,
          firstName = _this$state3.firstName,
          lastName = _this$state3.lastName,
          email = _this$state3.email,
          phoneNumber = _this$state3.phoneNumber,
          tip = _this$state3.tip,
          note = _this$state3.note,
          error = _this$state3.error,
          errors = _this$state3.errors,
          loadingError = _this$state3.loadingError,
          success = _this$state3.success,
          cartLoading = _this$state3.cartLoading,
          paymentLoading = _this$state3.paymentLoading,
          iframeLoading = _this$state3.iframeLoading,
          validatedCart = _this$state3.validatedCart;
      var locationId = this.props.locationId;

      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_CheckoutMessage["default"], {
          type: "negative",
          primaryMessage: "We could not submit your order.",
          secondaryMessage: error,
          tertiaryMessages: errors,
          actionName: "Retry",
          actionCallback: this.resetErrors
        });
      }

      if (loadingError) {
        return /*#__PURE__*/_react["default"].createElement(_CheckoutMessage["default"], {
          type: "negative",
          primaryMessage: "Error loading the cart.",
          secondaryMessage: loadingError
        });
      }

      if (success) {
        return /*#__PURE__*/_react["default"].createElement(_CheckoutMessage["default"], {
          type: "positive",
          primaryMessage: "Your order has been submitted.",
          secondaryMessage: "Check your inbox for a confirmation email."
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
        loading: cartLoading || paymentLoading || iframeLoading
      }, validatedCart && /*#__PURE__*/_react["default"].createElement(_CartDisplay["default"], {
        amounts: _objectSpread(_objectSpread({}, validatedCart.summary), {}, {
          tip: tip
        }),
        handleChange: this.handleChange
      }), !cartLoading && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h5", {
        style: {
          marginBottom: '0.5rem'
        }
      }, "Notes"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
        className: "checkout-modal-notes"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.TextArea, {
        style: {
          margin: '0 0.5rem'
        },
        label: "Notes",
        placeholder: "e.g. please include a fork or indicate car information if the restaurant allows curbside",
        name: "note",
        id: "note",
        onChange: this.handleChange,
        value: note
      }))), /*#__PURE__*/_react["default"].createElement("h5", {
        style: {
          marginBottom: '0.5rem'
        }
      }, "Contact Information"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, {
        widths: "equal"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
        required: true,
        label: "First Name",
        type: "text",
        id: "firstName",
        placeholder: "First Name",
        onChange: this.handleChange,
        value: firstName
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
        required: true,
        label: "Last Name",
        type: "text",
        id: "lastName",
        placeholder: "Last Name",
        onChange: this.handleChange,
        value: lastName
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, {
        widths: "equal"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
        required: true,
        label: "Email",
        type: "email",
        id: "email",
        placeholder: "Email",
        onChange: this.handleChange,
        value: email
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
        required: true
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Phone Number"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, null, /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], (0, _extends2["default"])({
        mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        guide: true,
        placeholder: "(123) 456-7890",
        id: "phoneNumber",
        value: phoneNumber,
        onChange: this.handleMaskedChange
      }, this.props)))))), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h5", {
        style: {
          marginBottom: '0.5rem'
        }
      }, "Payment"), /*#__PURE__*/_react["default"].createElement(_shift4iframe["default"], {
        locationId: locationId,
        handleSuccess: this.handleSuccess,
        handleFailure: this.handleFailure,
        handleLoadFailure: this.handleCartFailure,
        setLoading: function setLoading(value) {
          return _this3.setLoading('iframeLoading', value);
        }
      })), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.shift4.com/pdf/Lighthouse_Terms-and-Conditions.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Terms and Conditions")));
    }
  }]);
  return CheckoutBody;
}(_react["default"].Component);

exports["default"] = CheckoutBody;